import { Button } from '@/components/ui/Button'
import type { UserRecord } from '@/data/useUsers'
import { ROLE_LABEL } from '@/types/user'

interface UserTableProps {
  users: UserRecord[]
  onEdit: (user: UserRecord) => void
  onToggleSuspend: (user: UserRecord) => void
  onDelete: (user: UserRecord) => void
}

export function UserTable({ users, onEdit, onToggleSuspend, onDelete }: UserTableProps) {
  if (users.length === 0) {
    return <p className="text-slate-500">No users yet. Add your first user.</p>
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-[640px] text-left text-sm">
        <thead className="border-b border-slate-200 text-slate-500">
          <tr>
            <th className="px-4 py-3 font-medium">Name</th>
            <th className="px-4 py-3 font-medium">Email</th>
            <th className="px-4 py-3 font-medium">Role</th>
            <th className="px-4 py-3 font-medium">Projects</th>
            <th className="px-4 py-3 font-medium">Status</th>
            <th className="px-4 py-3 text-right font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-b border-slate-100 last:border-0">
              <td className="px-4 py-3 font-medium text-slate-800">{user.name}</td>
              <td className="px-4 py-3 text-slate-600">{user.email}</td>
              <td className="px-4 py-3">{ROLE_LABEL[user.role]}</td>
              <td className="px-4 py-3 text-slate-600">{user.projectCount}</td>
              <td className="px-4 py-3">
                {user.suspended ? (
                  <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700">
                    Suspended
                  </span>
                ) : (
                  <span className="rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
                    Active
                  </span>
                )}
              </td>
              <td className="px-4 py-3">
                <div className="flex justify-end gap-2">
                  <Button variant="secondary" onClick={() => onEdit(user)}>
                    Edit
                  </Button>
                  <Button variant="secondary" onClick={() => onToggleSuspend(user)}>
                    {user.suspended ? 'Reactivate' : 'Suspend'}
                  </Button>
                  <Button variant="danger" onClick={() => onDelete(user)}>
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
